/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import SiteMapWithStaticMarker from 'components/maps/SiteMapWithStaticMarker';

/**
 * Determines whether a value is a valid lat or lng value
 *
 * @param value
 */
// TODO: This function needs to be fleshed out. Currently it's just a placeholder
// TODO: This function needs a home with other similar helpers
const isValidLatLon = value => !!value;

/**
 * Reads and parses the Redux store's representation of the lat and lng input values from the
 * Site Information form. Returns an object containing the parsed lat and lng values.
 *
 * @param state
 */
const readCoordinates = (state) => {
  const readCoordinate = dimension => parseFloat(state.form.siteInfo.values[dimension]);
  return ({
    lat: readCoordinate('lat'),
    lng: readCoordinate('lng'),
  });
};

/**
 * Calculates where the center of the map should be based on lat and lng input to Site Information
 * Form as represented in Redux store
 *
 * @param state
 * @returns {{lat: number, lng: number}}
 */
const calculateCenter = (state) => {
  const { lat, lng } = readCoordinates(state);
  const defaultCenter = {
    lat: 0,
    lng: 0,
  };
  return {
    lat: isValidLatLon(lat) ? lat : defaultCenter.lat,
    lng: isValidLatLon(lng) ? lng : defaultCenter.lng,
  };
};

/**
 * Calculates the map's marker data based on lat and lng input to Site Information Form as
 * represented in Redux store
 * @param state
 */
const calculateMarkers = (state) => {
  const { lat, lng } = readCoordinates(state);
  if (!isValidLatLon(lat) || !isValidLatLon(lng)) return [];
  return [{
    key: 1,
    position: { lat, lng },
  }];
};

const mapStateToProps = state => ({
  center: calculateCenter(state),
  markers: calculateMarkers(state),
});

const SiteValidationMapContainer = connect(
  mapStateToProps
)(SiteMapWithStaticMarker);

export default SiteValidationMapContainer;
